import {connect} from '@modifi/redux'
import {aPush} from '@modifi/router'
import {compose} from 'ramda'
import {withSuspense} from '@modifi/plugin-onboarding'

import {
  aReset,
  aSavePage,
  selectInitialFormDataForCreation,
  selectInitializePagePending,
  selectSaveErrorMessage,
  selectSaveHasError,
  selectSavePending,
} from '../store'
import CreateIntermediaryShareHolders, {
  CreateIntermediaryShareHoldersProps,
} from './CreateIntermediaryShareHolders'

const mapStateToProps = (
  state: Record<string, any>
): Pick<
  CreateIntermediaryShareHoldersProps,
  'isLoading' | 'updatePending' | 'formData' | 'hasError' | 'errorMessage'
> => ({
  isLoading: selectInitializePagePending(state),
  updatePending: selectSavePending(state),
  formData: selectInitialFormDataForCreation(state),
  hasError: selectSaveHasError(state),
  errorMessage: selectSaveErrorMessage(state),
})

const mapDispatchToProps = {
  onSubmit: aSavePage,
  onDiscard: aReset,
  redirect: aPush,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  withSuspense(false)(CreateIntermediaryShareHolders)
)
